import React from 'react';
import { useIntl } from 'react-intl';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import { MdOutlineTimer } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import AppButton from '../app-button/AppButton';

function ExpiredNotice({ continueBtnText, continueRoutePath }) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const navigate = useNavigate();
  const handleBackToHome = () => {
    navigate('/');
  };
  const handleContinue = () => {
    if (continueRoutePath === 'searchResults') {
      navigate(-1);
    } else {
      navigate(0);
    }
  };

  return (
    <Modal
      backdrop="static"
      keyboard={false}
      show
      size="md"
      className="expired-notice"
    >
      <Modal.Body>
        <div className="d-flex align-items-center flex-column">
          <MdOutlineTimer style={{ fontSize: 60 }} />
          <h4 className="mt-3">{formattedMessage('session_expired')}</h4>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <AppButton
          variant="secondary"
          onClick={handleBackToHome}
          btnText={formattedMessage('back_to_home_btn')}
        />
        <AppButton onClick={handleContinue} btnText={continueBtnText} />
      </Modal.Footer>
    </Modal>
  );
}

ExpiredNotice.defaultProps = {
  continueBtnText: '',
  continueRoutePath: '/',
};

ExpiredNotice.propTypes = {
  continueBtnText: PropTypes.string,
  continueRoutePath: PropTypes.string,
};

export default ExpiredNotice;
